import React, { createContext, useState, useEffect, useContext } from 'react';
import petsPathTo from '../utils/Api/petsPathTo';
import { UserContext } from './UserContext';

const PetsContext = createContext();

const usePetsContext = () => useContext(PetsContext);

const PetsProvider = ({ children }) => {
  const [petsList, setPetsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentUser } = useContext(UserContext);

  const getPetsList = () => {
    setLoading(true);
    petsPathTo.list().then((result) => {
      setPetsList(result.data);
      setLoading(false);
      return petsList;
    });
    return petsList;
  }

  useEffect(() => {
    if (currentUser) {
      getPetsList();
    }
  }, [currentUser]);

  return (
    <PetsContext.Provider value={{ petsList, setPetsList, loading, getPetsList }}>
      {children}
    </PetsContext.Provider>
  );
};

export { PetsContext, PetsProvider, usePetsContext };
